import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { TranslateObjectPipe } from '../../pipes/translate-object.pipe';
/**
 * Activate Component
 */
let ActivateComponent = class ActivateComponent {
    constructor(httpClient, route, googleAnalyticsService, translateObjectPipe) {
        this.httpClient = httpClient;
        this.route = route;
        this.googleAnalyticsService = googleAnalyticsService;
        this.translateObjectPipe = translateObjectPipe;
        this.statusMessage = '';
        this.loginVisible = true;
    }
    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.httpClient.get('user/activate/' + params['hash']).subscribe((result) => {
                this.statusMessage = result['message'];
                if (result['userId']) {
                    let array = [];
                    array.push({
                        'event': 'accountCreated',
                        userId: result['userId']
                    });
                    this.googleAnalyticsService.pushGAEvents(array);
                    this.loginVisible = true;
                }
            }, (error) => {
                this.statusMessage = error.error['message'];
                this.loginVisible = false;
            });
        });
    }
};
ActivateComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: GoogleAnalyticsService },
    { type: TranslateObjectPipe }
];
ActivateComponent = __decorate([
    Component({
        selector: 'ecd-activate',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./activate.component.html")).default
    })
], ActivateComponent);
export { ActivateComponent };
